import { useEffect } from 'react';
import { useLocation, useNavigate } from '@tanstack/react-router';
import useFetchIam from '../api/useFetchIam';

/** トライアルプランでアクセスを許可するパスのプレフィックス */
const TRIAL_ALLOWED_PATHS = [
  '/agent/provided_job_posts',
  '/agent/provided_job_post_lists',
  '/agent/linked_accounts',
  '/agent/settings',
];

function isAllowedPath(pathname: string): boolean {
  return TRIAL_ALLOWED_PATHS.some(
    (allowed) => pathname === allowed || pathname.startsWith(`${allowed}/`)
  );
}

interface TrialRouteGuardProps {
  children: React.ReactNode;
}

export default function TrialRouteGuard({ children }: TrialRouteGuardProps) {
  const { data: iam, isLoading } = useFetchIam();
  const location = useLocation();
  const navigate = useNavigate();

  const isTrial = iam?.plan_type === 'trial';
  const onDisallowedPath = isTrial && !isAllowedPath(location.pathname);

  useEffect(() => {
    if (isLoading || !isTrial) return;

    if (!isAllowedPath(location.pathname)) {
      navigate({ to: '/agent/provided_job_posts', replace: true });
    }
  }, [isLoading, isTrial, location.pathname, navigate]);

  // トライアルプランかつ不許可パスの場合はリダイレクト待ちで何も表示しない
  if (onDisallowedPath) {
    return null;
  }

  return <>{children}</>;
}
